/* newsletter.js — one subscribe path for the whole site.
   Production: wall-kit intake service (POST /subscribe) — lands in
   subscribers.jsonl, reviewable via /subscribers?token=….
   (Shopify's /contact customer form is bot-challenged for XHR posts,
   so it silently dropped signups — replaced 2026-10-13.)
   Fallback: localStorage queue (exportQueue() drains it as CSV). */
(function(){
  async function subscribe(email, source){
    if(!email || !email.includes('@')) return {ok:false};
    try{
      const r = await fetch((window.LWA_KIT || 'https://lwa-email-bridge.fly.dev') + '/subscribe', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({email, source: source || 'site'})
      });
      const d = await r.json().catch(() => ({}));
      if(r.ok && !d.error){ try{ localStorage.setItem('lwa-email', email); }catch(e){} return {ok:true}; }
    }catch(e){ /* service unreachable — fall through to the local queue */ }
    try{
      const q = JSON.parse(localStorage.getItem('lwa-emails')||'[]');
      if(!q.find(x=>x.email===email)){ q.push({email, source, at:new Date().toISOString()}); }
      localStorage.setItem('lwa-emails', JSON.stringify(q));
    }catch(e){}
    return {ok:true};
  }
  function exportQueue(){
    const q = JSON.parse(localStorage.getItem('lwa-emails')||'[]');
    const csv = 'email,source,at\n' + q.map(x=>`${x.email},${x.source},${x.at}`).join('\n');
    const a = document.createElement('a');
    a.href = 'data:text/csv;charset=utf-8,'+encodeURIComponent(csv);
    a.download = 'lwa-emails.csv'; a.click();
  }
  window.LWA_NEWS = {subscribe, exportQueue};
})();
